// const { getParentUrlOrigin } = require('../../utils/urlUtils').default;
import { getParentUrlOrigin } from '../../utils/urlUtils';

export default class Options {
  constructor() {
    this.consentManagement = {};
    this.priceGranularity = 'dense';
    this.pageUrl = getParentUrlOrigin();
  }

  setConsetManagement(consentManagement) {
    this.consentManagement = consentManagement;
    return this;
  }

  build() {
    return {
      consentManagement: this.consentManagement,
      priceGranularity: this.priceGranularity,
      pageUrl: this.pageUrl,
    };
  }
}
